import MainLayout from "@/layouts/MainLayout.vue";
import UserSpaces from "@/views/Main/UserSpaces.vue";

import LicencePrivate from "@/views/Main/LicencePrivat.vue";
import ProfileView from "@/views/Main/ProfileView.vue";
import CreateOrganization from "@/views/Main/Organization/CreateOrganization.vue";
import EditOrganization from "@/views/Main/Organization/EditOrganization.vue";
import SuccessView from "@/views/Payment/SuccessView.vue";
import CancelView from "@/views/Payment/CancelView.vue";
import CheckoutView from "@/views/Payment/CheckoutView.vue";
import InvoicePaymentView from "@/views/Payment/InvoicePaymentView.vue";
import InvoiceCompleteView from "@/views/Payment/InvoiceCompleteView.vue";

const baseDataRoutes = [
  {
    path: "/",
    name: "main",
    component: MainLayout,
    // params: { nodeId: "locations" },
    children: [
      {
        path: "",
        name: "user-spaces",
        component: UserSpaces
      },
      {
        path: "licence/private",
        name: "licence-private",
        component: LicencePrivate
      },
      {
        path: "profile",
        name: "profile",
        component: ProfileView
      },
      {
        path: "organization/create",
        name: "organization-create",
        component: CreateOrganization
      },
      {
        path: "organization/:id",
        name: "organization",
        component: EditOrganization
      },
      {
        path: "payment/success/:licence_id/:checkout_id",
        name: "payment-success",
        component: SuccessView
      },
      {
        path: "payment/checkout/:licence_id/:session_id",
        name: "payment-checkout",
        component: CheckoutView
      },
      {
        path: "payment/invoice/:licence_id/:invoice_id",
        name: "payment-invoice",
        component: InvoicePaymentView
      },
      {
        path: "payment/invoice-complete/:licence_id/:invoice_id",
        name: "payment-invoice-complete",
        component: InvoiceCompleteView
      },
      {
        path: "payment/cancel",
        name: "payment-cancel",
        component: CancelView
      }
    ]
  }
];
export default baseDataRoutes;
